import { useMemo } from "react";
import { getImageStyleClasses } from "../utils/imageStyleUtils";

const useImageStyle = (component = null) => {
  const { styleClasses, inlineStyles } = useMemo(() => {
    if (!component || !component.image_style) {
      return { styleClasses: "", inlineStyles: {} };
    }

    const data = getImageStyleClasses(component.image_style);
    return {
      styleClasses: data?.className || "",
      inlineStyles: data?.style || "",
    };
  }, [component]);

  return {
    styleClasses,
    inlineStyles,
    styleProps: {
      className: styleClasses,
      style: inlineStyles,
    },
  };
};

export default useImageStyle;
